/**
 * Late-bound entry for the mutually recursive command parser (ticket 3525,
 * upstream pin e3e7cc3f, MIT). Upstream keeps the whole parser in one file,
 * where the recursion is plain
 * function calls; the size-ratchet split turned those calls into import
 * cycles. Parse, Programs, and Wrappers call through this dispatcher, and
 * workLogCommandLabels registers the real implementation at module load.
 *
 * @module workLogCommandDispatcher
 */

import { MAX_COMMAND_SEGMENTS, type CommandProgramContext } from "./workLogCommandTokens";

type CommandProgramNameInternal = (
  command: string,
  depth: number,
  context: CommandProgramContext,
  segmentsRemaining?: number,
) => string | null;

let implementation: CommandProgramNameInternal = () => null;

export function commandProgramNameInternal(
  command: string,
  depth: number,
  context: CommandProgramContext,
  segmentsRemaining: number = MAX_COMMAND_SEGMENTS,
): string | null {
  return implementation(command, depth, context, segmentsRemaining);
}

export function registerCommandProgramNameInternal(fn: CommandProgramNameInternal) {
  implementation = fn;
}
